import { Wording } from '@/types';

export const MEDITATION_WORDING_FR: Wording = {
  components_header_media_content: 'Audios',
  components_header_media_1: 'Méditations',
  components_header_media_2: 'Podcast',
  components_header_text1: 'Guides',
  components_header_text2: 'Blog',
  components_header_members: 'Membres',
  hero_text: 'Là où la méditation rencontre les étoiles',
  hero_button_text: 'Commencez votre voyage vers l\'intérieur',
  components_ressources_section_title: 'RESSOURCES',
  components_ressources_subheader_text: 'Outils pour la paix intérieure, l\'ancrage et l\'équilibre au quotidien',
  components_ressources_span_text: 'Ouvrez la porte à la paix intérieure grâce à nos méditations et guides soigneusement sélectionnés. Trouvez la clarté, reconnectez-vous à votre respiration et alignez-vous sur votre rythme intérieur, un instant de pleine conscience à la fois.',
  components_ressources_card_1_title: 'Réflexion',
  components_ressources_card_1_text: 'Courtes méditations et réflexions audio pour centrer vos pensées et vous réaligner avec votre rythme cosmique.',
  components_ressources_card_2_title: 'Explorez les profondeurs',
  components_ressources_card_2_text: 'Voyagez au-delà de la surface avec des guides immersifs qui mélangent méditation, astrologie et introspection pour une transformation durable.',
  components_ressources_link: 'Voir plus',
  components_notes_and_google_title_1: 'Guidage spirituel',
  components_notes_and_google_title_2: 'Rituels de pleine conscience',
  components_notes_and_google_title_3: 'Méditations guidées',
  components_review_google_text: 'Avis Google',
  media_content_section_title: 'AUDIOS',
  media_content_section_subheader_text: 'Nos méditations',
  text_media_1: '',
  text_media_2: '',
  media_content_section_button_more: 'En savoir plus',
  text2_section_title: 'BLOG',
  text2_section_subheader_text: '',
  text2_section_button_more: '',
  components_text1_section_title: 'GUIDES',
  components_text1_subheader_text: 'Connaissances cosmiques pour l\'alignement quotidien',
  components_text1_span_text: 'Alignez-vous sur les rythmes de l\'univers : explorez une collection organisée de guides astrologiques et méditatifs approfondis conçus pour éveiller la clarté intérieure, approfondir la conscience de soi et soutenir votre voyage de croissance spirituelle et céleste.',
  components_text1_card_1_title: 'Ouvert au calme',
  components_text1_card_1_text: 'Commencez votre voyage avec des guides fondamentaux de méditation et d\'astrologie, idéaux pour les chercheurs attirés par le calme intérieur, les modèles cosmiques et la perspicacité personnelle.',
  components_text1_card_3_title: 'Lien corps-esprit',
  components_text1_card_3_text: 'Découvrez les couches profondes de votre monde intérieur. Ces guides transcendent la surface pour révéler le sens, les émotions et les schémas de pleine conscience qui façonnent votre expérience.',
  components_text1_card_2_title: 'Réfléchir et intégrer',
  components_text1_card_2_text: 'Des blocages émotionnels aux cycles planétaires, ces guides offrent des outils de réflexion, de guérison et de transformation à travers des rituels conscients et la sagesse astrologique.',
  components_text1_link: 'Voir tous les guides',
  components_footer_text: 'Réveillez-vous de l\'intérieur : votre calme, votre force',
  components_footer_info: 'Informations',
  components_footer_registration_number: 'Numéro d\'enregistrement',
  components_footer_legal: 'Légal',
  components_footer_terms: 'Termes et conditions',
  components_footer_privacy: 'politique de confidentialité',
  button_load_more: 'Charger plus',
  page_media_1_content_hero_text: 'Méditations',
  page_media_content_menu_antistress: 'Antistress',
  page_media_content_menu_mindfulness: 'Pleine conscience',
  page_media_content_menu_energyboost: 'Boost d\'énergie',
  page_media_content_menu_mantra: 'Mantra',
  page_media_2_content_hero_text: '',
  page_text1_hero_text: 'Guides',
  page_text1_section_title: 'Guides',
  page_text1_subheader_text: 'Nos guides',
  page_text2_hero_text: '',
  page_text2_section_title: '',
  page_text2_subheader_text: '',
  enter_email_title: 'Veuillez entrer votre email pour continuer',
  enter_email_placeholder_email: 'E-mail',
  enter_email_button_enter: 'Entrer',
  components_login_success_text: 'Connexion réussie !',
  components_card_link_media_content: 'Écoutez maintenant',
  components_card_link_text1_content: 'Voir le guide',
  components_card_link_text2_content: 'Explorer',
  france: 'France',
  cyprus: 'Chypre',
  tag_podcast: 'Podcast',
  tag_meditation: 'Méditation',
  page_media_content_menu_all: 'Tous',
};